import {
  CopyOutlined,
  MessageOutlined,
  WarningFilled,
} from "@ant-design/icons";
import { Col, Divider, Row, Skeleton, Typography, message } from "antd";
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "../ServerSideStates";
import { FC, useState } from "react";
import SendMessage from "./SendMessage";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";


const CreateContactInfoes: FC<{ externalAdvert?: any }> = ({
  externalAdvert,
}) => {
  const [searchParams] = useSearchParams();
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const advertId = searchParams.get("id");
  const advertDetails = useGetAdvertDetails(
    advertId || externalAdvert?.id || ""
  );
  const detailsData = advertDetails?.data?.data || null;
  const { Text } = Typography;
  const [isShowMessageInput, setIsShowMessageInput] = useState(false);

  const handleCopy = (phoneNumber: string) => {
    navigator.clipboard
      .writeText(phoneNumber)
      .then(() => {
        message.success("Telefon numarası kopyalandı!");
      })
      .catch(() => {
        message.error("Telefon numarası kopyalanamadı!");
      });
  };

  return (
    <>
      <Col xs={24}>
        <Row gutter={[0, 20]}>
          <Skeleton
            loading={advertDetails.isLoading || advertDetails.isFetching}
          >
            {detailsData && (
              <>
                <Col xs={24} className="!flex justify-center">
                  <Text className="!text-2xl !font-bold !text-black">
                    İletişim Kur
                  </Text>
                </Col>
                
                {/* İletişim seçenekleri kontrolü */}
                {detailsData.advertContactType && detailsData.advertContactType.length > 0 ? (
                  <>
                    {/* Telefon seçeneği */}
                    {detailsData?.user?.phoneNumber &&
                    detailsData?.advertContactType.some(
                      (item: any) => item.contactTypeId === 1
                    ) && (
                      <>
                        <Col
                          xs={24}
                          className="!flex items-center gap-3 hover:cursor-pointer"
                        >
                          <CopyOutlined  onClick={() =>
                            handleCopy(
                              detailsData?.user?.phoneNumber
                            )
                          } className="!text-lg !text-indigo-500" />

                          <a
                            className="!text-indigo-500"
                            href={`tel:${detailsData?.user?.phoneNumber || ""}`}
                            style={{
                              userSelect: "none",
                              textDecoration: "none",
                              color: "inherit",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {detailsData?.user?.phoneNumber || ""}
                          </a>
                        </Col>
                        <Col xs={24}>
                          <Divider className="!m-0" />
                        </Col>
                      </>
                    )}

                    {/* Mesaj seçeneği */}
                    {detailsData?.advertContactType.some(
                      (item: any) => item.contactTypeId === 2
                    ) && (
                      <>
                        <Col
                          xs={24}
                          className="!flex items-center gap-3 hover:cursor-pointer"
                          onClick={() => {
                            if (userInfoes) {
                              setIsShowMessageInput(true);
                            } else {
                              openNotificationWithIcon(
                                "error",
                                "Soru Sormak için giriş yapmanız lazım"
                              );
                            }
                          }}
                        >
                          <MessageOutlined className="!text-lg !text-red-500" />
                          <Text className="!text-red-500">Mesaj Gönder</Text>
                        </Col>
                        {isShowMessageInput && (
                          <>
                            <SendMessage externalAdvert={externalAdvert} onFinish={()=>{}} />
                            <Col xs={24}>
                              <Divider className="!m-0" />
                            </Col>
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  // İletişim tercihi belirlenmemişse
                  <Col xs={24} className="!text-center !py-4">
                    <Text type="secondary">
                      İlan sahibi iletişim tercihi belirlememiş
                    </Text>
                  </Col>
                )}

                {/* Uyarı mesajı her durumda gösterilsin */}
                <Col className="!p-2 !bg-[#f9f9f9] !rounded-md !flex gap-2 !items-center ">
                  <WarningFilled className="!text-black !text-[25px]" />
                  <Text className="!text-black !text-xs">
                    Herhangi bir ödeme yapmadan önce ilanın doğruluğundan emin
                    olun.
                  </Text>
                </Col>
              </>
            )}
          </Skeleton>
        </Row>
      </Col>
    </>
  );
};

export default CreateContactInfoes;